import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Errore inatteso" };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary:", error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      const onCassa = typeof window !== "undefined" && String(window.location?.pathname || "").startsWith("/cassa");
      return (
        <div className="min-h-screen flex flex-col items-center justify-center p-8 text-center bg-[#F7F7F8]" data-testid="error-boundary">
          <h2 className="font-heading text-xl font-semibold text-[#18181B] mb-2">La cassa non è riuscita ad aprirsi</h2>
          <p className="text-sm text-[#71717A] max-w-md mb-6">{this.state.message}</p>
          <div className="flex flex-wrap gap-3 justify-center">
            <button
              type="button"
              className="h-11 px-5 rounded-xl bg-[#18181B] text-white text-sm"
              onClick={() => {
                this.setState({ hasError: false, message: "" });
                this.props.onReset?.();
                if (onCassa) window.location.reload();
              }}
            >
              Riprova
            </button>
            {onCassa && (
              <button
                type="button"
                className="h-11 px-5 rounded-xl border border-[#E4E4E7] bg-white text-sm text-[#18181B]"
                onClick={() => { window.location.href = "/cassa"; }}
              >
                Torna alle modalità
              </button>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
